import React from 'react';
import misionImage from '../../assets/images/about/MISION.png';
import visionImage from '../../assets/images/about/VISION.png';
import valoresImage from '../../assets/images/about/VALORES.png';
import aboutBanner from '../../assets/images/banners/about_banner.png';

const About = () => {
    return (
        <>
        <section className="about-hero pt-20 relative"
            style={{backgroundImage: `url(${aboutBanner})`, backgroundSize: 'cover', backgroundPosition: 'top'}}
        >
            <div className="absolute inset-0 bg-black bg-opacity-40"></div>
            <div className="contain relative z-10">
               <div className="w-1/2 h-full mt-36">
                    <h2 className="text-white">¿Quienes somos?</h2>
                    <p className="text-gray-400">Salient es una empresa mexicana que integra soluciones tecnológicas, energéticas y de marketing para potenciar el crecimiento de negocios y hogares en todo el país. Nuestra filosofía es clara: <span className="font-bold">hacer las cosas bien, con estrategia, eficiencia y corazón.</span></p>
                    <p className="text-gray-400 mt-2">Contamos con un equipo de especialistas en redes, software, marketing digital y ventas, comprometidos con ofrecer un servicio personalizado, transparente y de alto valor.</p>
               </div>
            </div>
        </section>
        <section className="bg-salient-neutral-secondary">
            <div className="contain py-20">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div className="relative mvv-card">
                        <div className="rounded-lg overflow-hidden">
                            <img src={misionImage} alt="" className="mvv-img w-full h-96 object-cover"/>
                        </div>
                        <div className="mvv-details relative flex flex-col gap-4 px-6 py-10 text-center bg-white rounded-lg">
                            <div className="mvv-icon bg-salient-primary">
                                <i className="fa fa-bullseye text-white"></i>
                            </div>
                            <a href="" className="mvv-title w-auto m-auto text-center">
                                <h3 className="font-bold">Misión</h3>
                            </a>
                            <p>Ser un hub confiable e innovador que conecte a las personas y empresas con soluciones tecnológicas sostenibles, eficientes y a la medida.</p>
                        </div>
                    </div>
                    <div className="relative mvv-card">
                        <div className="rounded-lg overflow-hidden">
                            <img src={visionImage} alt="" className="mvv-img w-full h-96 object-cover"/>
                        </div>
                        <div className="mvv-details relative flex flex-col gap-4 px-6 py-10 text-center bg-white rounded-lg">
                            <div className="mvv-icon bg-salient-primary">
                                <i className="fa fa-bullseye text-white"></i>
                            </div>
                            <a href="" className="mvv-title w-auto m-auto text-center">
                                <h3 className="font-bold">Visión</h3>
                            </a>
                            <p>Ofrecer soluciones prácticas y escalables en tecnología, marketing y energía, con un enfoque integral, honesto y orientado a resultados reales.</p>
                        </div>
                    </div>
                </div>
                <div className="mt-10">
                    <div className="relative mvv-card mvv-card-r flex flex-row">
                        <div className="rounded-lg overflow-hidden w-full">
                            <img src={valoresImage} alt="" className="mvv-img w-full h-96 object-cover"/>
                        </div>
                        <div className="mvv-details mvv-details-r relative flex flex-col gap-4 px-6 py-10 text-center bg-white rounded-lg">
                            <div className="mvv-icon bg-salient-primary">
                                <i className="fa fa-bullseye text-white"></i>
                            </div>
                            <a href="" className="mvv-title w-auto m-auto text-center">
                                <h3 className="font-bold">Valores</h3>
                            </a>
                            <p>En Salient trabajamos con integridad, compromiso y calidad, ofreciendo soluciones prácticas y sostenibles. Mantenemos una relación cercana con nuestros clientes y fomentamos la innovación para integrar tecnología, marketing y energía de forma inteligente y eficiente.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    );
};

export default About;